import script from "./CategoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryCard.vue?vue&type=script&setup=true&lang=js"

import "./CategoryCard.vue?vue&type=style&index=0&id=4dd699e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd699e2"]])

export default __exports__